import React from 'react';
import { Link } from 'react-router-dom';

export const LOGO_SRC = `${process.env.PUBLIC_URL}/img/mfleague4-logo.png`;
export const LOGO_SRC_DARK = `${process.env.PUBLIC_URL}/img/mfleague4-logo-dark.png`;

const SIZE_CLASS = {
  sm: 'h-7',
  md: 'h-9',
  lg: 'h-11',
  xl: 'h-14',
};

/**
 * MFLeague 4 brand logo (transparent PNG)
 * @param {'sm'|'md'|'lg'|'xl'} size
 * @param {boolean} onDark — inverted cutout for slate/dark backgrounds
 * @param {boolean} linkToDashboard — wrap in Link to /dashboard
 */
const BrandLogo = ({
  size = 'md',
  onDark = false,
  linkToDashboard = false,
  center = false,
  className = '',
  subtitle,
}) => {
  const img = (
    <img
      src={onDark ? LOGO_SRC_DARK : LOGO_SRC}
      alt="MFLeague 4"
      className={`${SIZE_CLASS[size]} w-auto object-contain object-left ${className}`}
      draggable={false}
    />
  );

  const block = (
    <div className={`flex flex-col gap-1.5 min-w-0 ${center ? 'items-center' : ''}`}>
      {img}
      {subtitle && (
        <span className={`text-slate-400 text-xs font-medium tracking-wide ${center ? 'text-center' : ''}`}>
          {subtitle}
        </span>
      )}
    </div>
  );

  if (linkToDashboard) {
    return (
      <Link to="/dashboard" className="block hover:opacity-90 transition-opacity">
        {block}
      </Link>
    );
  }

  return block;
};

export default BrandLogo;
